export enum EndUserExtendedRegistrationStatus {
  ABSENT = 'absent',
  CONFIRMED = 'confirmed',
  SUSPENSE = 'suspense',
  REJECTED = 'rejected',
  CANCELED = 'canceled',
}

export const endUserExtendedRegistrationStatusType = {
  [EndUserExtendedRegistrationStatus.ABSENT]: 'ic-status_blue',
  [EndUserExtendedRegistrationStatus.CONFIRMED]: 'ic-status_green',
  [EndUserExtendedRegistrationStatus.SUSPENSE]: 'ic-status_orange',
  [EndUserExtendedRegistrationStatus.REJECTED]: 'ic-status_red',
  [EndUserExtendedRegistrationStatus.CANCELED]: 'ic-status_grey',
};

export enum EmployeeExtendedRegistrationTypes {
  ABSENT = 'absent',
  CONFIRMED = 'confirmed',
  SUSPENSE = 'suspense',
  REJECTED = 'rejected',
  REMOVED = 'removed',
  CANCELED = 'canceled',
  REQUESTED = 'requested',
}

export type EmployeeExtendedRegistrationType
  = typeof EmployeeExtendedRegistrationTypes[keyof typeof EmployeeExtendedRegistrationTypes];


export const employeeExtendedRegistrationStatusType = {
  [EmployeeExtendedRegistrationTypes.ABSENT]: 'ic-status_blue',
  [EmployeeExtendedRegistrationTypes.CONFIRMED]: 'ic-status_green',
  [EmployeeExtendedRegistrationTypes.SUSPENSE]: 'ic-status_orange',
  [EmployeeExtendedRegistrationTypes.REJECTED]: 'ic-status_red',
  [EmployeeExtendedRegistrationTypes.REMOVED]: 'ic-status_red',
  [EmployeeExtendedRegistrationTypes.CANCELED]: 'ic-status_grey',
  [EmployeeExtendedRegistrationTypes.REQUESTED]: 'ic-status_blue',
};
